import { FaPlane, FaTrain, FaBus, FaCar, FaShip, FaTaxi, FaPlus } from 'react-icons/fa';

// Travel type definitions with UI metadata and validation rules
export const TRAVEL_TYPES = {
    flight: {
        icon: FaPlane,
        label: 'Flight',
        fields: {
            airline: { required: true, type: 'text', label: 'Airline' },
            flightNumber: { required: true, type: 'text', label: 'Flight Number' },
            departureAirport: { required: true, type: 'text', label: 'Departure Airport' },
            arrivalAirport: { required: true, type: 'text', label: 'Arrival Airport' },
            departureTime: { required: true, type: 'datetime', label: 'Departure Time' },
            arrivalTime: { required: true, type: 'datetime', label: 'Arrival Time' },
            bookingReference: { required: false, type: 'text', label: 'Booking Reference' },
            class: { required: false, type: 'text', label: 'Class' },
            baggage: { required: false, type: 'text', label: 'Baggage Allowance' }
        },
        createSummary: (details) => `${details.airline} ${details.flightNumber}: ${details.departureAirport} to ${details.arrivalAirport}`
    },
    train: {
        icon: FaTrain,
        label: 'Train',
        fields: {
            operator: { required: true, type: 'text', label: 'Train Operator' },
            trainNumber: { required: true, type: 'text', label: 'Train Number/Service' },
            departureStation: { required: true, type: 'text', label: 'Departure Station' },
            arrivalStation: { required: true, type: 'text', label: 'Arrival Station' },
            departureTime: { required: true, type: 'datetime', label: 'Departure Time' },
            arrivalTime: { required: true, type: 'datetime', label: 'Arrival Time' },
            bookingReference: { required: false, type: 'text', label: 'Booking Reference' },
            class: { required: false, type: 'text', label: 'Class' },
            seat: { required: false, type: 'text', label: 'Seat/Carriage' }
        },
        createSummary: (details) => `${details.operator} ${details.trainNumber}: ${details.departureStation} to ${details.arrivalStation}`
    },
    car: {
        icon: FaCar,
        label: 'Car',
        fields: {
            rentalCompany: { required: true, type: 'text', label: 'Rental Company' },
            pickupLocation: { required: true, type: 'text', label: 'Pickup Location' },
            returnLocation: { required: true, type: 'text', label: 'Return Location' },
            pickupTime: { required: true, type: 'datetime', label: 'Pickup Time' },
            returnTime: { required: true, type: 'datetime', label: 'Return Time' },
            vehicleClass: { required: false, type: 'text', label: 'Vehicle Class' },
            bookingReference: { required: false, type: 'text', label: 'Booking Reference' }
        },
        createSummary: (details) => `${details.rentalCompany} car rental: ${details.pickupLocation} to ${details.returnLocation}`
    },
    cruise: {
        icon: FaShip,
        label: 'Cruise',
        fields: {
            cruiseLine: { required: true, type: 'text', label: 'Cruise Line' },
            shipName: { required: true, type: 'text', label: 'Ship Name' },
            departurePort: { required: true, type: 'text', label: 'Departure Port' },
            arrivalPort: { required: true, type: 'text', label: 'Arrival Port' },
            departureTime: { required: true, type: 'datetime', label: 'Departure Time' },
            arrivalTime: { required: true, type: 'datetime', label: 'Arrival Time' },
            cabin: { required: false, type: 'text', label: 'Cabin Details' },
            bookingReference: { required: false, type: 'text', label: 'Booking Reference' }
        },
        createSummary: (details) => `${details.cruiseLine} ${details.shipName}: ${details.departurePort} to ${details.arrivalPort}`
    },
    bus: {
        icon: FaBus,
        label: 'Bus',
        fields: {
            operator: { required: true, type: 'text', label: 'Bus Operator' },
            serviceNumber: { required: true, type: 'text', label: 'Service Number' },
            departureStop: { required: true, type: 'text', label: 'Departure Stop' },
            arrivalStop: { required: true, type: 'text', label: 'Arrival Stop' },
            departureTime: { required: true, type: 'datetime', label: 'Departure Time' },
            arrivalTime: { required: true, type: 'datetime', label: 'Arrival Time' },
            bookingReference: { required: false, type: 'text', label: 'Booking Reference' }
        },
        createSummary: (details) => `${details.operator} ${details.serviceNumber}: ${details.departureStop} to ${details.arrivalStop}`
    },
    ferry: {
        icon: FaShip,
        label: 'Ferry',
        fields: {
            operator: { required: true, type: 'text', label: 'Ferry Operator' },
            departurePort: { required: true, type: 'text', label: 'Departure Port' },
            arrivalPort: { required: true, type: 'text', label: 'Arrival Port' },
            departureTime: { required: true, type: 'datetime', label: 'Departure Time' },
            arrivalTime: { required: true, type: 'datetime', label: 'Arrival Time' },
            bookingReference: { required: false, type: 'text', label: 'Booking Reference' }
        },
        createSummary: (details) => `${details.operator} ferry: ${details.departurePort} to ${details.arrivalPort}`
    },
    custom: {
        icon: FaPlus,
        label: 'Custom',
        fields: {
            name: { required: true, type: 'text', label: 'Transport Name' },
            type: { required: true, type: 'text', label: 'Transport Type' },
            departureLocation: { required: true, type: 'text', label: 'Departure Location' },
            arrivalLocation: { required: true, type: 'text', label: 'Arrival Location' },
            departureTime: { required: true, type: 'datetime', label: 'Departure Time' },
            arrivalTime: { required: true, type: 'datetime', label: 'Arrival Time' },
            details: { required: false, type: 'text', label: 'Additional Details' }
        },
        createSummary: (details) => `${details.type} ${details.name}: ${details.departureLocation} to ${details.arrivalLocation}`
    }
}; 